<template>
  <base-floating-card @close="close">
    <div id="edit-contact-card">
      <div id="contact-data-wrapper">
        <editable-field
          class="scs-input"
          title="First Name:"
          inputType="text"
          :value="contact.given_name"
          @scs-input="givenNameInput"
          @scs-blur="submitGivenName"
        />
        <editable-field
          class="scs-input"
          title="Last Name:"
          inputType="text"
          :value="contact.family_name"
          @scs-input="familyNameInput"
          @scs-blur="submitFamilyName"
        />
        <editable-field
          class="scs-input"
          title="Phone Number:"
          inputType="text"
          :value="contact.phoneNumber"
          @scs-input="phoneNumberInput"
          @scs-blur="submitPhoneNumber"
        />
        <editable-field
          class="scs-input"
          title="Email Address:"
          inputType="text"
          :value="contact.email"
          @scs-input="emailInput"
          @scs-blur="submitEmail"
        />
      </div>
    </div>
  </base-floating-card>
</template>
<script>
import BaseFloatingCard from "../BaseFloatingCard.vue";
import EditableField from "../../EditableField.vue";
import { formatDate, formatTime } from "../../../../Helpers/invoice.js";
export default {
  data() {
    return {
      given_name: undefined,
      family_name: undefined,
      phoneNumber: undefined,
      email: undefined,
    };
  },

  methods: {
    formatDate,
    formatTime,
    givenNameInput(val) {
      this.given_name = val;
    },
    familyNameInput(val) {
      this.family_name = val;
    },
    phoneNumberInput(val) {
      this.phoneNumber = val;
    },
    emailInput(val) {
      this.email = val;
    },
    async submitGivenName() {
      if (this.given_name) {
        let editPayload = {
          variable: "given_name",
          value: this.given_name,
          key: {
            userId: this.contact.userId,
            tenantId: this.contact.tenantId,
          },
        };
        await this.$store.dispatch("editContact", editPayload);
      }
    },
    async submitFamilyName() {
      if (this.family_name) {
        let editPayload = {
          variable: "family_name",
          value: this.family_name,
          key: {
            userId: this.contact.userId,
            tenantId: this.contact.tenantId,
          },
        };
        await this.$store.dispatch("editContact", editPayload);
      }
    },
    async submitPhoneNumber() {
      if (this.phoneNumber) {
        let editPayload = {
          variable: "phoneNumber",
          value: this.phoneNumber,
          key: {
            userId: this.contact.userId,
            tenantId: this.contact.tenantId,
          },
        };
        await this.$store.dispatch("editContact", editPayload);
      }
    },
    async submitEmail() {
      if (this.email) {
        let editPayload = {
          variable: "email",
          value: this.email,
          key: {
            userId: this.contact.userId,
            tenantId: this.contact.tenantId,
          },
        };
        await this.$store.dispatch("editContact", editPayload);
      }
    },

    close() {
      this.$emit("close");
    },
  },
  components: {
    BaseFloatingCard,
    EditableField,
  },
  emits: ["close"],
  props: ["contact"],
};
</script>
<style scoped>
@media screen {
  #contact-data-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: auto;
    justify-content: space-evenly;
  }
  .scs-input {
    width: 250px;
  }
  @media (min-width: 800px) {
    #edit-contact-card {
      width: 500px;
    }

    #contact-data-wrapper {
      flex-direction: row;
    }
    .scs-input {
      width: 300px;
    }
  }
}
</style>
